<template>
  <article>
    <div class="card-post" v-for="(post, index) in posts" :key="index">
      <div class="category">
        <router-link :to="{ name: 'category', params: { categorySlug: post._embedded['wp:term'][0][0].slug }}">
          {{ post._embedded['wp:term'][0][0].name }}
        </router-link>
      </div>
      <router-link :to="{ name: 'post', params: { postSlug: post.slug }}">
          <div class="img-gradient">
            <img
              v-if="post._embedded['wp:featuredmedia']"
              :src="post._embedded['wp:featuredmedia'][0].source_url"
              class="card-post-img-2"
            />
          </div>
      </router-link>
      <div class="card-post-info">
          <div class="post-title">
            <router-link :to="{ name: 'post', params: { postSlug: post.slug }}">
              <span v-html="post.title.rendered"></span>
            </router-link>
          </div>
          <div class="post-author">
            <router-link :to="{ name:'author', params: {authorId: post._embedded.author[0].id} }">
              {{post._embedded.author[0].name}}
            </router-link>
          </div>
      </div>
    </div>
  </article>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: 'DisertacionesVI',
  props: {
    category: String,
  },
  data() {
    return {
      // Wordpress Posts Endpoint
      postsUrl: "https://foto-urbana.credopop.com/wp-json/wp/v2/posts?afu_portada_posicion=6",
      queryOptions: {
        per_page: 1, // Only retrieve the 10 most recent blog posts.
        page: 1, // Current page of the collection.
        _embed: true //Response should include embedded resources.
      },
      // Returned Posts in an Array
      posts: []
    };
  },
  methods: {
    // Get Recent Posts From WordPress Site
    getRecentMessages() {
      axios
        .get(this.postsUrl, { params: this.queryOptions })
        .then(response => {
          this.posts = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getPostDate(date) {
      return moment(date).format("lll");
    }
  },
  mounted() {
    this.getRecentMessages();
  }
};

</script>

<style scoped>
a,
a:link,
a:visited,
a:active {
  color: #000000;
  opacity: 1.0;
  text-decoration: none;
}

a:hover {
  color: #000000;
  opacity: 0.5;
  text-decoration: none;
}

.card-post {
  position: relative;
  height: 480px;
  /*width: 25%;*/
  transition: all 0.3s ease-in-out;
  z-index: 1;
  margin: 0!important;
}
.card-post:hover{
    box-shadow: 0px 0px 60px 1px rgba(131,128,122,0.39);
    transition: all 0.3s ease-in-out;
    z-index: 1;
}
.category {
    position: absolute;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #FFFFFF;
    padding-left: 20px;
    bottom: 220px;
    z-index: 999;
}
.category a,
.category a:link,
.category a:visited {
  color: #ffffff;
}
.img-gradient {
    position: relative;
    display: inline-block;
    height: 280px;
    width: 100%;
    height: 280px;
    object-fit: cover;
    object-position: center center;
}
.img-gradient:after {
  content:'';
  position:absolute;
  left:0; top:0;
  width:100%; height:100%;
  display:inline-block;
  background: linear-gradient(179.97deg, rgba(0, 0, 0, 0.0) 60.33%,  rgba(0, 0, 0, 0.8) 84.85%);
}
.img-gradient img {
    display: block;
}
.card-post-img-2 {
    width: 100%;
    height: 280px;
    object-fit: cover;
}
.card-post-info {
    height: 200px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    position: relative;
}
.post-title {
    padding-left: 20px;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    width: 90%;
    text-align: left;
}
.post-author {
    padding-top: 15px;
    padding-left: 20px;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    text-align: left;
}
/*.card-post:last-child {
  display: none;
}*/
@media only screen and (max-width:1255px){
    .img-aliados{
        height: 120px;
        padding: 10px;
    }
}


@media only screen and (max-width: 1150px) {

    .menu{
        display: none;
    }
    .res-menu{
        display: inline !important;
        font-size: 30px;
        padding-top: 10px;
        cursor: pointer;
    }
}

@media only screen and (max-width: 768px) {
  /*.card-post:last-child {
    display: block;
  }*/
}

@media only screen and (max-width: 640px){
    .card-post {
      height: auto;
    }
    .logo-text {
        width: 62px;
        font-family: Raleway;
        font-style: normal;
        font-weight: bold;
        font-size: 10px;
        line-height: 11px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding-left: 9px;
        padding-top: 11px;
    }

    .search {
        width: 160px;
    }

    .title-about{
        width: 100%;
        font-size: 25px;
    }

    .about-afu{
        width: 100%;
        height: 380px;
    }
    .img-gradient, .card-post-img-2{
        height: 180px;
    }


    .yellow{
        width: 100% !important;
    }
    .home-slider{
        width: 100%;
        height: auto;
    }
    .slideshow-container {
        height: auto !important;
    }
    .img-aliados{
        height: 90px;
        padding: 1px;
    }
    .footer-container{
        padding-left: 40px;
        flex-direction: column;
    }
    footer{
        height: auto;
    }
}
</style>
